<template>
	<div class="toast" v-show="info">
		<div class="text" :info="info">{{info}}</div>
	</div>
</template>

<script>
	export default {
		props: ['info'],
		data() {
			return {

			}
		}
	}
</script>

<style scoped="scoped">
	.toast {
		position: fixed;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		background: #111111;
		border-radius: .2rem;
		opacity: 0.8;
		z-index: 999;
	}

	.text {
		font-size: .28rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		line-height: .4rem;
		padding: .28rem .4rem;
		box-sizing: border-box;
		white-space: nowrap;
	}
</style>
